import { securedAxiosInstance } from "../axios";
import { toSnakeCase } from "@estaly/ui";

class BillingEntitiesService {
  fetchBillingEntities(params) {
    return securedAxiosInstance.get("/billing_entities", { params: toSnakeCase(params) });
  }

  fetchBillingEntity(id, params) {
    return securedAxiosInstance.get(`/billing_entities/${id}`, { params: toSnakeCase(params) });
  }

  createBillingEntity(data) {
    return securedAxiosInstance.post("/billing_entities", toSnakeCase(data));
  }

  updateBillingEntity(id, data) {
    return securedAxiosInstance.put(`/billing_entities/${id}`, toSnakeCase(data));
  }
}

export default new BillingEntitiesService();
